// Canonical person-URN sentinels shared across the server/UI boundary.
//
// SOLO_SELF is WRITTEN by the Play profile layer
// (excellent/src/play/profile.ts → reconcileSoloOwnership) and READ BACK by the
// UI PersonPicker (packages/ui/src/blocks/person-picker.tsx) to render
// "Just me (solo)". The two layers must agree byte-for-byte, so the literal
// lives here — a dependency-free, client-safe home both sides already import —
// instead of being re-declared on each side, which let the value drift silently
// with no compile error (every solo owner field would then render as a raw
// "solo:self" URN instead of "Just me").
//
// Not a resolvable URN: a single-player workspace has no registered member to
// point at, so "who owns this? — me" records this sentinel rather than faking a
// member identity (no numeric id).
export const SOLO_SELF = "solo:self";
